<section class="content">
  <div class="content-block">
    <div class="block-header">
      <app-breadcrumb [title]="'MENUITEMS.ATTENDANCE.TEXT' | translate"
                      [items]="[('restConfigurationsCatalog.breadcrumb' | translate)]"></app-breadcrumb>
    </div>

    <div class="rest-configuration-workspace"
         [class.rest-configuration-workspace--loading]="isLoading">
      <mat-card class="rest-configuration-panel rest-configuration-panel--detail">
        <div class="rest-configuration-panel__header">
          <div class="rest-configuration-panel__heading">
            <span class="rest-configuration-panel__eyebrow">{{ 'restConfigurationsCatalog.breadcrumb' | translate }}</span>
            <h3>{{ detailTitle }}</h3>
            <p>{{ detailDescription }}</p>
          </div>
          <div class="rest-configuration-panel__actions">
            @if (selectedConfiguration && isViewMode) {
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-primary"
                    *appCanAccess="updateAccess"
                    (click)="startEdit()">
              <mat-icon>edit</mat-icon>
              {{ 'common.update' | translate }}
            </button>
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-danger"
                    *appCanAccess="deleteAccess"
                    (click)="deleteSelected()">
              <mat-icon>delete_outline</mat-icon>
              {{ 'common.delete' | translate }}
            </button>
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-neutral"
                    (click)="goBackToList()">
              <mat-icon>arrow_back</mat-icon>
              {{ 'common.back' | translate }}
            </button>
            }
            @if (isCreateMode || isEditMode) {
            <button mat-flat-button
                    type="button"
                    class="btn-tone-primary"
                    (click)="save()"
                    [disabled]="isSaving || !canSave">
              <mat-icon>save</mat-icon>
              {{ isCreateMode ? ('common.create' | translate) : ('common.saveChanges' | translate) }}
            </button>
            <button mat-stroked-button
                    type="button"
                    class="btn-tone-neutral"
                    (click)="cancelEdit()"
                    [disabled]="isSaving">
              <mat-icon>arrow_back</mat-icon>
              {{ 'common.cancel' | translate }}
            </button>
            }
          </div>
        </div>

        <div class="rest-configuration-panel__body">
          @if (isCreateMode || isEditMode) {
          <div class="rest-configuration-editor">
            <div class="card rest-configuration-editor__section mb-0">
              <div class="card-body">
                <div class="rest-configuration-section-heading">
                  <div class="rest-configuration-section-heading__title">
                    <h4>{{ 'restConfigurationsCatalog.sections.general' | translate }}</h4>
                    <span class="rest-configuration-required-badge">{{ 'common.requiredLabel' | translate }}</span>
                  </div>
                  <p>{{ 'restConfigurationsCatalog.sections.generalDescription' | translate }}</p>
                </div>

                <div class="row g-3">
                  @if (hasMultipleCompanies) {
                  <div class="col-12">
                    <app-company-select [records]="companies" [value]="form.companiesRecordId"
                                        [label]="'orgUnitsCatalog.fields.company' | translate"
                                        [placeholder]="'orgUnitsCatalog.fields.company' | translate"
                                        [disabled]="isSaving"
                                        (valueChange)="form.companiesRecordId = $event; selectedCompanyId = $event; onCompanyChange()" />
                  </div>
                  }
                  <div class="col-12 col-lg-6">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'restConfigurationsCatalog.fields.name' | translate }}</mat-label>
                      <input matInput
                             [(ngModel)]="form.name"
                             [disabled]="isSaving"
                             [placeholder]="'restConfigurationsCatalog.fields.namePlaceholder' | translate">
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-lg-6">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'restConfigurationsCatalog.fields.mode' | translate }}</mat-label>
                      <mat-select [(ngModel)]="form.mode"
                                  [disabled]="isSaving"
                                  (ngModelChange)="onModeChange()">
                        @for (restMode of restConfigurationModes; track restMode) {
                        <mat-option [value]="restMode">{{ ('restConfigurationsCatalog.modeOptions.' + restMode) | translate }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  @if (isEditMode) {
                  <div class="col-12">
                    <div class="rest-configuration-toggle-card">
                      <div>
                        <strong>{{ 'restConfigurationsCatalog.fields.status' | translate }}</strong>
                        <p>{{ 'restConfigurationsCatalog.fields.statusHint' | translate }}</p>
                      </div>
                      <mat-slide-toggle [(ngModel)]="form.isActive"
                                        [disabled]="isSaving">
                      </mat-slide-toggle>
                    </div>
                  </div>
                  }
                </div>
              </div>
            </div>

            <div class="card rest-configuration-editor__section mb-0">
              <div class="card-body">
                <div class="rest-configuration-section-heading">
                  <div class="rest-configuration-section-heading__title">
                    <h4>{{ 'restConfigurationsCatalog.sections.rules' | translate }}</h4>
                    <span class="rest-configuration-required-badge">{{ 'common.requiredLabel' | translate }}</span>
                  </div>
                  <p>{{ 'restConfigurationsCatalog.sections.rulesDescription' | translate }}</p>
                </div>

                <div class="row g-3">
                  @if (isFixedWeekdayMode) {
                  <div class="col-12">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'restConfigurationsCatalog.fields.weekdays' | translate }}</mat-label>
                      <mat-select [(ngModel)]="form.weekdays"
                                  [disabled]="isSaving"
                                  multiple>
                        @for (weekday of weekdayOptions; track weekday) {
                        <mat-option [value]="weekday">{{ ('restConfigurationsCatalog.weekdayOptions.' + weekday) | translate }}</mat-option>
                        }
                      </mat-select>
                      <mat-hint>{{ 'restConfigurationsCatalog.fields.weekdaysHint' | translate }}</mat-hint>
                    </mat-form-field>
                  </div>
                  }

                  @if (isCycleReferenceMode) {
                  <div class="col-12 col-lg-6">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'restConfigurationsCatalog.fields.cycleReference' | translate }}</mat-label>
                      <mat-select [(ngModel)]="form.cycleReference"
                                  [disabled]="isSaving"
                                  (ngModelChange)="reconcileCycleReference()">
                        @for (cycle of availableWorkCycles; track cycle.workCycleId) {
                        <mat-option [value]="cycle.workCycleId">{{ cycle.name }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="col-12 col-lg-6">
                    <mat-form-field subscriptSizing="dynamic" appearance="outline">
                      <mat-label>{{ 'restConfigurationsCatalog.fields.restDays' | translate }}</mat-label>
                      <mat-select [(ngModel)]="form.restDays"
                                  [disabled]="isSaving || !form.cycleReference"
                                  multiple>
                        @for (restDay of availableRestDayOptions; track restDay) {
                        <mat-option [value]="restDay">{{ 'restConfigurationsCatalog.labels.dayNumber' | translate:{ day: restDay } }}</mat-option>
                        }
                      </mat-select>
                      <mat-hint>{{ 'restConfigurationsCatalog.fields.restDaysHint' | translate }}</mat-hint>
                    </mat-form-field>
                  </div>
                  }
                </div>
              </div>
            </div>
          </div>
          } @else if (selectedConfiguration; as config) {
          <div class="rest-configuration-detail">
            <div class="card rest-configuration-detail__summary mb-0">
              <div class="card-body">
                <div class="row g-3">
                  <div class="col-md-6 col-xl-3">
                    <div class="rest-configuration-metric-card">
                      <span>{{ 'restConfigurationsCatalog.fields.mode' | translate }}</span>
                      <strong>{{ getModeLabel(config.mode) }}</strong>
                    </div>
                  </div>
                  <div class="col-md-6 col-xl-3">
                    <div class="rest-configuration-metric-card">
                      <span>{{ 'restConfigurationsCatalog.fields.summary' | translate }}</span>
                      <strong>{{ config.summaryLabel }}</strong>
                    </div>
                  </div>
                  <div class="col-md-6 col-xl-3">
                    <div class="rest-configuration-metric-card">
                      <span>{{ 'restConfigurationsCatalog.fields.cycleReference' | translate }}</span>
                      <strong>{{ getCycleName(config.cycleReference) }}</strong>
                    </div>
                  </div>
                  <div class="col-md-6 col-xl-3">
                    <div class="rest-configuration-metric-card">
                      <span>{{ 'restConfigurationsCatalog.fields.status' | translate }}</span>
                      <strong>{{ config.isActive ? ('common.status.active' | translate) : ('common.status.inactive' | translate) }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card rest-configuration-detail__section-card mb-0">
              <div class="card-body">
                <div class="rest-configuration-section-heading">
                  <h4>{{ 'restConfigurationsCatalog.sections.configuration' | translate }}</h4>
                  <p>{{ 'restConfigurationsCatalog.sections.configurationDescription' | translate }}</p>
                </div>
                <div class="row g-3">
                  <div class="col-md-6">
                    <div class="rest-configuration-soft-card">
                      <span>{{ 'orgUnitsCatalog.fields.company' | translate }}</span>
                      <strong>{{ getCompanyName(config.companiesRecordId) }}</strong>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="rest-configuration-soft-card">
                      <span>{{ 'restConfigurationsCatalog.fields.name' | translate }}</span>
                      <strong>{{ config.name }}</strong>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="rest-configuration-soft-card">
                      <span>{{ 'restConfigurationsCatalog.fields.weekdays' | translate }}</span>
                      <strong>{{ getWeekdaysLabel(config.weekdays) }}</strong>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="rest-configuration-soft-card">
                      <span>{{ 'restConfigurationsCatalog.fields.restDays' | translate }}</span>
                      <strong>{{ getRestDaysLabel(config.restDays) }}</strong>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="rest-configuration-soft-card">
                      <span>{{ 'restConfigurationsCatalog.fields.cycleReference' | translate }}</span>
                      <strong>{{ getCycleName(config.cycleReference) }}</strong>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="rest-configuration-soft-card">
                      <span>{{ 'restConfigurationsCatalog.fields.mode' | translate }}</span>
                      <strong>{{ getModeLabel(config.mode) }}</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          } @else {
          <div class="rest-configuration-empty">
            <mat-icon>hotel_class</mat-icon>
            <h4>{{ 'restConfigurationsCatalog.emptyEditorTitle' | translate }}</h4>
            <p>{{ 'restConfigurationsCatalog.emptyEditorDescription' | translate }}</p>
          </div>
          }
        </div>
      </mat-card>

      @if (isLoading) {
      <app-loading-state class="rest-configuration-loading"
                         [message]="'restConfigurationsCatalog.loading' | translate" />
      }
    </div>
  </div>
</section>
